import styled from "styled-components";

export const BinTableWrapper = styled.div`
  .disabled {
    background-color: #90ee909c;
    cursor: not-allowed;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: none !important;
  }
`;
